import { useParams } from 'react-router-dom';

import { Stack } from '@mui/material';

import { MasterIndexApiPath } from '@/api';
import { withLoader, WithLoaderProps } from '@/hocs';

import { RelatedRecordsTable } from '../RelatedRecordsTable';
import { PersonRelatedRecords } from './PersonRelatedRecords';

const MasterIndexRelatedRecords = ({
  type,
  idKey = 'id',
  viewId,
}: WithLoaderProps & {
  type: MasterIndexApiPath;
  idKey?: string;
  viewId?: string;
}) => {
  const { [idKey]: id } = useParams();
  const recordId = id || viewId;

  if (type === MasterIndexApiPath.People && recordId) {
    return <PersonRelatedRecords recordId={recordId} />;
  }

  return (
    <Stack gap={2} display="flex" flex={1} overflow="auto">
      <Stack flex={1} height="100%" overflow="auto">
        <RelatedRecordsTable recordId={recordId} type={type} />
      </Stack>
    </Stack>
  );
};

export default withLoader(MasterIndexRelatedRecords);
